import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { CommonService } from "../services/common.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
@Component({
	selector: "app-step",
	templateUrl: "./step.component.html",
	styleUrls: ["./step.component.scss"],
	encapsulation: ViewEncapsulation.None, // 🔥 esto es clave
})
export class StepComponent implements OnInit {
	asks = [];
	commit = "";
	recomendation;
	respLow = "";
	respMid = "";
	respHigth = "";
	escala;
	objective = [
		"Control de peso.",
		"Estar en forma, saludable.",
		"Fuerza y definición.",
		"Rendimiento deportivo.",
	];
	objective1 = [
		"Controle do peso",
		"Estar em forma, saudável.",
		"Força e definição.",
		"Rendimento desportivo",
	];

	objective2 = [
		"Weight management.",
		" To be fit, healthy.",
		" Strength and definition.",
		"Sports Performance.",
	];
	questions;
	opcion = "";
	respZone: any = [];
	respZone2: any = [];
	respObj = [];
	low = false;
	mid = false;
	higth = false;
	selectRecomendation: string;
	optionRecomendation: string[] = ["Si", "no"];
	optionRecomendation1: string[] = ["Yes", "no"];
	optionRecomendation2: string[] = ["Sim", "Não"];
	selectObjetive: string;

	zone = [
		{
			id: 1,
			text: "Sala fitness: fuerza y peso libre",
			isChecked: false,
			idioma: "esp",
		},
		{ id: 2, text: "Sala cardio", isChecked: false, idioma: "esp" },
		{ id: 3, text: "Actividades dirigidas", isChecked: false, idioma: "esp" },
		{ id: 4, text: "Piscina", isChecked: false, idioma: "esp" },
		{ id: 5, text: "Zona Spa", isChecked: false, idioma: "esp" },
		{ id: 6, text: "Pistas de pádel / tenis", isChecked: false, idioma: "esp" },
		{ id: 7, text: "En el exterior", isChecked: false, idioma: "esp" },
		{ id: 8, text: "Otras salas", isChecked: false, idioma: "esp" },
		{
			id: 1,
			text: "Sala fitness: força e peso livre",
			isChecked: false,
			idioma: "por",
		},
		{ id: 2, text: "Equipamento Cardio", isChecked: false, idioma: "por" },
		{ id: 3, text: "Aulas de grupo", isChecked: false, idioma: "por" },
		{ id: 4, text: "Piscina", isChecked: false, idioma: "por" },
		{ id: 5, text: "SPA", isChecked: false, idioma: "por" },
		{ id: 6, text: "Campos de Padel", isChecked: false, idioma: "por" },
		{ id: 7, text: "No exterior", isChecked: false, idioma: "por" },
		{ id: 8, text: "Outras salas", isChecked: false, idioma: "por" },
		{
			id: 1,
			text: "Fitness room: strength and free weight",
			isChecked: false,
			idioma: "eng",
		},
		{ id: 2, text: "cardio room", isChecked: false, idioma: "eng" },
		{ id: 3, text: "Guided activities", isChecked: false, idioma: "eng" },
		{ id: 4, text: "Pool", isChecked: false, idioma: "eng" },
		{ id: 5, text: "Spa area", isChecked: false, idioma: "eng" },
		{ id: 6, text: "Padel / tennis courts", isChecked: false, idioma: "eng" },
		{ id: 7, text: "Outdoor", isChecked: false, idioma: "eng" },
		{ id: 8, text: "Other rooms", isChecked: false, idioma: "eng" },
	];
	zoneFit = [
		{
			id: 1,
			text: "Zona de iniciaci\xf3n para el trabajo de fuerza (hay dos TVs de ayuda) (STARTING POINT)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 2,
			text: "Zona de calentamiento y estiramiento. (RECOVERY ZONE)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 3,
			text: "Zona de entrenamiento funcional. (TRAINING EXPERIENCE ZONE)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 4,
			text: "Zona prepara para el entrenamiento de potencia con grandes cargas. (LIFT ZONE)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 5,
			text: "Zona de peso libre. (PESO LIBRE)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 6,
			text: "Zona para el entrenamiento de la aptitud cardio-pulmonar. (ZONA CARDIOVASCULAR)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 7,
			text: "Zona de fuerza con m\xe1quinas guiadas de diferentes grupos musculares. (ZONA DE M\xc1QUINAS SELECTORIZADAS)",
			isChecked: false,
			idioma: "esp",
		},
		{
			id: 1,
			text: "Zona de STARTING POINT para o trabalho de for\xe7a (existem dois televisores para assist\xeancia)",
			isChecked: false,
			idioma: "por",
		},
		{
			id: 2,
			text: "Zona de aquecimento e de alongamentos (RECOVERY ZONE)",
			isChecked: false,
			idioma: "por",
		},
		{
			id: 3,
			text: "Zona de treino funcional (TRAINING EXPERIENCE ZONE)",
			isChecked: false,
			idioma: "por",
		},
		{
			id: 4,
			text: "Zona preparada para o treino de for\xe7a com pesos pesados (LIFT ZONE)",
			isChecked: false,
			idioma: "por",
		},
		{
			id: 5,
			text: "Zona de pesos livres (PESO LIVRE)",
			isChecked: false,
			idioma: "por",
		},
		{
			id: 6,
			text: "Zona para treino de aptid\xe3o cardio-pulmonar (CARDIOVASCULAR ZONE).",
			isChecked: false,
			idioma: "por",
		},
		{
			id: 7,
			text: "Zona de for\xe7a com m\xe1quinas orientadas para diferentes grupos musculares (\xc1REA DE M\xc1QUINAS SELECCIONADAS)",
			isChecked: false,
			idioma: "por",
		},
	];
	lang;
	step = 0;
	loading = true;
	flag;
	survey;
	centro;
	aux = [];
	aux2 = [];
	start = false;
	isMobile = false;
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private common: CommonService,
		private _snackBar: MatSnackBar,
		private breakpointObserver: BreakpointObserver
	) {}

	async home() {
		await this.route.params.subscribe(async (parameter: any) => {
			console.log(parameter);

			if (!parameter.id) {
				this.loading = false;
				this.flag = false;
				console.log("no existe parametro id");
			} else {
				console.log("otra cos");
				// this.loading = false;
				// localStorage.setItem("BQT.token", parameter.id);
				window.sessionStorage.setItem("BQT.token", parameter.id);
				this.common
					.getSurveyFirst()
					.then((res: any) => {
						console.log("por aqui");
						console.log(res);
						this.start = true;
						this.centro = res.survey.relationCustomer.curso;
						console.log(this.centro);
						if (res.ok === false) {
							console.log("por aqui");
							this.flag = false;
							return;
						}
						console.log("por aqui");

						this.loading = false;
						this.flag = true;
						this.survey = res.survey;
						// settear idioma segun pais
						this.lang = "esp";
						localStorage.setItem("idioma", "esp");

						let ar = res.fields.map((f, idx) =>
							this.normalizeField(f, idx + 1)
						);
						this.questions = ar;
						// localStorage.setItem("preguntas", JSON.stringify(ar));
					})
					.catch((err) => {
						console.log(err);
					});
			}
		});
	}
	startSurvey() {
		console.log("iniciar encuesta");
		this.router.navigate(["/step", { page: 0 }]);
	}

	async ngOnInit() {
		this.breakpointObserver
			.observe([Breakpoints.Handset])
			.subscribe((result) => {
				this.isMobile = result.matches;
				console.log("¿Es móvil?", this.isMobile);
			});
		await this.home();
		await this.otro();
	}

	// updateText(i, t) {
	//   console.log(i, t.target.value);
	//   this.asks[2] = {commit:t.target.value};
	// }

	async otro() {
		this.questions = localStorage.getItem("preguntas");
		this.lang = localStorage.getItem("idioma");
		this.questions = JSON.parse(this.questions);
		console.log(this.questions);
		this.zone.sort(() => Math.random() - 0.5);
		this.objective.sort(() => Math.random() - 0.5);
		console.log();
	}
	private normalizeField(field: any, index: number) {
		let initialValue: any = null;

		switch (field.type) {
			case "scale":
				initialValue = null;
				break;
			case "text":
			case "textarea":
				initialValue = "";
				break;
			case "boolean":
				initialValue = false;
				break;
			case "list":
				initialValue = null;
				break;
			case "group":
				// si trae subitems, inicializarlos
				initialValue = field.subitems?.map(() => null) || [];
				break;
		}

		return {
			key: "p" + index,
			name: field.name,
			type: field.type,
			scale: field.scale || null, // para escalas
			options: field.options || null, // para listas
			subitems: field.subitems || null, // para grupos
			value: initialValue,
			optional: field.optional || false,
		};
	}

	updateGroup(i: number, subIndex: number, value: any) {
		if (
			this.questions &&
			this.questions[i] &&
			Array.isArray(this.questions[i].value)
		) {
			this.questions[i].value[subIndex] = value;
			console.log(
				`Updated group question at index ${i}, subIndex ${subIndex} with value:`,
				value
			);
			// Additional processing can be added here if needed
		}
	}
	updateRadio2(field) {
		console.log(field.value);
		this.step = 3;
		this.respObj = field.value;
		let resp = {
			escala: this.escala,
			commit: this.commit,
			zones: this.aux.toString(),
			zoneFitness: this.aux2.toString(),
			recomendacion: this.opcion,
			objetivo: this.respObj,
		};
		console.log(resp);
		console.log(this.centro);
		this.common.finishSurvey(resp).then((res: any) => {
			if (res.ok == true) {
				if (this.escala > 8) {
					this.router.navigate(["/thanks-promotor", this.centro]);
				} else {
					this.router.navigate(["/thanks"]);
				}
			}
		});
	}

	someComplete(id: any) {
		console.log(id);
		this.step = 2;
		if (this.zone == null) {
			return false;
		}
		this.respZone = this.zone.filter((t) => t.isChecked == true);
		console.log(this.respZone);

		for (const r of this.respZone) {
			if (r.isChecked == true) {
				this.aux.push(r.text);
			}
		}
		console.log(this.aux);
		this.aux = this.aux.filter((item, index) => {
			return this.aux.indexOf(item) === index;
		});
		this.respZone2 = this.zoneFit.filter((t) => t.isChecked == true);
		for (const r of this.respZone2) {
			if (r.isChecked == true) {
				this.aux2.push(r.text);
			}
		}
		console.log(this.aux2);
		this.aux2 = this.aux2.filter((item, index) => {
			return this.aux2.indexOf(item) === index;
		});
		let resp = {
			escala: this.escala,
			commit: this.commit,
			zones: this.aux.toString(),
			zoneFitness: this.aux2.toString(),
			recomendacion: this.opcion,
			objetivo: this.respObj,
		};
		console.log(resp);

		this.common.noFinishSurvey(resp).then((res: any) => {
			console.log(res);
		});
	}

	updateCheck(id) {
		console.log(id);
		for (let item of this.zone) {
			if (item.id == id) {
				console.log(item.isChecked);
				if (item.isChecked == true) {
					item.isChecked = false;
					// this.respZone.push(id)
				} else {
					item.isChecked = true;
					// this.respZone = this.respZone.filter((item) => item !== id);
				}
				// console.log(this.respZone);
			}
		}
		// this.asks[3]={zone:this.aux}
	}

	update(i, t) {
		this.step = 0.4;
		console.log(this.step);

		// guardar el valor en la pregunta correspondiente
		this.questions[i].value = t;
		console.log("Respuesta actualizada:", this.questions[i], i);

		// opcional: actualizar escala si necesitas esa variable para lógicas internas
		this.escala = this.questions[i].value;

		// enviar todas las preguntas con sus respuestas
		console.log("Enviando cuestionario parcial:", this.questions);

		this.common.noFinishSurvey(this.questions).then((res: any) => {
			console.log("Respuesta del backend:", res);
		});
	}
	toContinue() {
		this.step = 0.5;
	}
	// updateText2(i, t) {
	//   console.log(i, t.target.value);
	//   this.asks[5] = {objetivo:t.target.value};
	// }

	// update(index, field) {
	//   console.log(index);
	//   console.log(field.value);
	//   console.log((this.asks[index] = 1));
	//   this.asks[index] = {recomendacionEscala:field.value};
	//   console.log(this.asks[1]);
	// }
	updateRadio(field) {
		console.log(field.value);
		console.log(this.selectRecomendation);
		this.step = 3;
		this.opcion = field.value;

		let resp = {
			escala: this.escala,
			commit: this.commit,
			zones: this.aux.toString(),
			recomendacion: this.opcion,
			objetivo: this.respObj,
		};
		console.log(resp);

		this.common.noFinishSurvey(resp).then((res: any) => {
			console.log(res);
		});
	}

	save() {
		// validación mínima
		if (!this.questions || this.questions.length === 0) {
			alert("No hay respuestas para guardar");
			return;
		}
		console.log("Guardando encuesta completa:", this.questions);
		this.common.finishSurvey(this.questions).then((res: any) => {
			if (res.ok === true) {
				// usamos la primera respuesta (pregunta 1)
				const primeraRespuesta = this.questions[0]?.value;
				if (primeraRespuesta > 8) {
					this.router.navigate(["/thanks-promotor", this.centro]);
				} else {
					this.router.navigate(["/thanks"]);
				}
			}
		});
	}
	valuechange(evt) {
		this.step = 1;
		console.log(this.step);
	}
	changeFlag(flag) {
		console.log(flag);
		this.lang = flag;
		this.common.getSurvey(flag).then((res: any) => {
			console.log(res);

			if (res.fields.length == 0) {
				if (this.lang == "esp") {
					this._snackBar.open(
						"No existe traduccion para este cuestionario",
						"Ok",
						{
							duration: 2000,
						}
					);
				} else if (this.lang == "eng") {
					this._snackBar.open("There is no translation for this survey", "Ok", {
						duration: 2000,
					});
				} else if (this.lang == "por") {
					this._snackBar.open("There is no translation for this survey", "Ok", {
						duration: 2000,
					});
				}

				return;
			}
			let ar = [];
			let index = 1;
			let xvalue = null;
			for (let field of res.fields) {
				if (field.type == "scale") {
					xvalue = null;
				}
				if (field.type == "boolean") {
					xvalue = false;
				}
				if (field.type == "textarea") {
					xvalue = "";
				}
				if (field.type == "text") {
					xvalue = "";
				}
				let json = {
					key: "p" + index,
					name: field.name,
					type: field.type,
					value: xvalue,
				};
				ar.push(json);
				index++;
				localStorage.setItem("idioma", field.lang);
			}
			localStorage.setItem("preguntas", JSON.stringify(ar));
			this.questions = ar;
		});
	}
	next() {
		if (this.escala > 8) {
			this.router.navigate(["/thanks-promotor", this.centro]);
		} else {
			this.router.navigate(["/thanks"]);
		}
	}
	getEscalaClass(val: any) {
		return {
			xsel: val !== undefined,
			["xsel-" + val]: val !== undefined,
		};
	}
}
